import React, {useState} from 'react';
import {TextInput, View} from 'react-native';

import {S, STATUS, T} from '../courseTheme';
import CCText from '../../../Atoms/CCText';
import {E} from './editorTheme';
import {Button, Sheet} from './ui';

type Props = {
  /** "Rename course" / "Rename chapter": the sheet's title. */
  title: string;
  value: string;
  saving?: boolean;
  /** A refusal from the server, shown under the field. */
  error?: string | null;
  onSave: (name: string) => void;
  onClose: () => void;
};

const MAX_NAME_CHARS = 120;

/**
 * A name, typed by hand: the reviewer's, not the AI's. Saves only a changed,
 * non-empty name.
 */
export default function RenameSheet({title, value, saving, error, onSave, onClose}: Props) {
  const [text, setText] = useState(value);
  const name = text.trim();
  const unchanged = name === value.trim();
  const disabled = !name || unchanged || !!saving;
  return (
    <Sheet title={title} onClose={onClose} width={480}>
      <View style={{padding: S[5], gap: S[3]}}>
        <TextInput
          value={text}
          onChangeText={t => setText(t.slice(0, MAX_NAME_CHARS))}
          accessibilityLabel="Name"
          autoFocus
          selectTextOnFocus
          returnKeyType="done"
          onSubmitEditing={() => !disabled && onSave(name)}
          style={{
            minHeight: 44,
            borderWidth: 1,
            borderColor: E.inputLine,
            borderRadius: 10,
            paddingHorizontal: S[3],
            fontSize: T.base,
            color: E.ink,
          }}
        />
        {error ? (
          <CCText accessibilityRole="alert" style={{fontSize: T.sm, color: STATUS.bad.fg}}>
            {error}
          </CCText>
        ) : null}
        <View style={{flexDirection: 'row', gap: S[2], justifyContent: 'flex-end'}}>
          <Button label="Cancel" variant="quiet" onPress={onClose} />
          <Button
            label="Save name"
            variant="accent"
            icon="checkmark"
            disabled={disabled}
            onPress={() => onSave(name)}
          />
        </View>
      </View>
    </Sheet>
  );
}
